<template>
  <b-list-group-item
    action
    class="border-0 px-0 clickable"
    @click="$emit('open', message.id, !isMessageViewed)"
  >
    <b-row no-gutters>
      <b-col cols="4" class="d-flex justify-content-start">
        <span>
          <i
            v-if="isMessageViewed"
            class="mdi mdi-email-open mr-2 font_size_1350 v2_line_height_24"
          />
          <i
            v-else
            class="mdi mdi-email-outline mr-2 font_size_1350 v2_line_height_24"
          />
        </span>
        <span v-if="message.sender">From: {{ message.sender }}</span>
        <span v-else-if="message.receiver">To: {{ message.receiver }}</span>
      </b-col>
      <b-col cols="5" xl="4" class="d-flex justify-content-center">
        <long-string-with-tooltip
          :delay="400"
          :length="subjectLength"
          :text="message.subject"
          :target-key="`message-subj-${message.id}`"
        />
      </b-col>
      <b-col
        cols="3"
        xl="4"
        class="d-flex justify-content-end justify-content-xl-center"
      >
        {{ $dayjs(message.sent_date).format('MM/DD/YYYY') }}
      </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script>
import LongStringWithTooltip from '@/components/ui-elements/LongStringWithTooltip';

export default {
  name: 'MessageListItem',
  props: {
    message: Object,
  },
  components: {
    LongStringWithTooltip,
  },
  computed: {
    subjectLength: function () {
      if (this.windowWidth >= 1600) return 40;
      if (this.windowWidth >= 1400) return 36;
      if (this.windowWidth >= 1300) return 32;
      return 28;
    },
    isMessageViewed: function () {
      return Boolean(
        !this.message.sender ||
          (this.message && this.message.to_first_viewed_date)
      );
    },
  },
};
</script>

<style scoped></style>
